// shell/VMark.jsx — Phase 0 Vesta "V" mark stand-in (btc design-match build)
//
// Renders the text "V" on the gradient tile that represents the Vesta logo mark.
// This is a ship-quality stand-in until Billy exports the real SVG path from Figma.
// When the real SVG arrives, replace the inner <span> with the <svg> path — every
// call site updates at once since they all import this single component.
//
// Usage:
//   <VMark size={20} />                    // ActorChip (8px font, 800 weight)
//   <VMark size={34} />                    // SessionDrawer header (17px font)
//   <VMark size={32} />                    // Chat assistant avatar
//
// Props:
//   size    — px width+height of the gradient square (default 24)
//   radius  — border-radius in px (default size/4, rounds nicely at all sizes)
//   className — optional extra class for the wrapper

import React from "react"

const GRADIENT_STYLE = {
  background: "linear-gradient(135deg, #5349E5 0%, #7C3AED 100%)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  userSelect: "none",
}

const VMark = ({ size = 24, radius, className, style }) => {
  const r = radius !== undefined ? radius : Math.round(size / 4)
  // Font size scales with the tile: roughly 50% of size, capped so it reads clearly.
  // spec: ActorChip (size≈20) → 8px/800; drawer (size≈34) → 17px; chat (size≈32) → ~14px.
  const fontSize = Math.max(7, Math.round(size * 0.5))

  return (
    <span
      className={className}
      style={{
        ...GRADIENT_STYLE,
        width: size,
        height: size,
        borderRadius: r,
        ...style,
      }}
      aria-hidden="true"
    >
      <span
        style={{
          color: "#ffffff",
          fontWeight: 800,
          fontSize,
          lineHeight: 1,
          fontFamily: "Manrope, system-ui, sans-serif",
          letterSpacing: "-0.03em",
        }}
      >
        V
      </span>
    </span>
  )
}

export default VMark
